export var AllowedPermissions;
(function (AllowedPermissions) {
    AllowedPermissions["READ_WRITE"] = "readWrite";
    AllowedPermissions["READ_ONLY"] = "readOnly";
    AllowedPermissions["NONE"] = "none";
})(AllowedPermissions || (AllowedPermissions = {}));
